import { render, staticRenderFns } from "./BoxOpen.vue?vue&type=template&id=0ce53e00"
import script from "./BoxOpen.vue?vue&type=script&lang=js"
export * from "./BoxOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports